export default __webpack_public_path__ + "media/images/wide_channel_logo-0a641b79803449bc5d0d9a04f31a0eb3.svg";